"use strict";

(function () {

	angular.module('app.userlogin')
		.controller('resetController', resetController);

	resetController.$inject = ['$http', '$scope', '$route', '$location', '$timeout', 'httpRequest', 'localizationService', 'utilFunctions'];

	function resetController($http, $scope, $route, $location, $timeout, httpRequest, localizationService, utilFunctions) {
		var vm = this;
		vm.email = "";
		vm.URL = window.location.href;
		vm.token = vm.URL.substring(vm.URL.indexOf("?") + 1);
		vm.user = null;
		vm.isValid = false;
		vm.newPass = "";
		vm.confirmPass = "";
		vm.hideMsg = true;
		vm.stringNo = null;
		vm.msgClass = "";
		vm.noMatch = false;
		vm.successfulReset = false;
		vm.badPass = false;
		vm.localStrings = [];
		vm.showPage = false;

		var init = function () {
			localizationService.getTaskBrowserLocalStrings(109).then(function (taskStrings) {
				vm.localStrings = angular.copy(taskStrings);
				vm.showPage = true;
			});
		};

		vm.getLocalString = function (stringNum) {
			var idx = utilFunctions.getIndexByProperty(vm.localStrings, "StringNum", stringNum);
			return (idx != -1) ? vm.localStrings[idx].LocalText : "String Not Found";
		}

		$scope.$on('$routeChangeSuccess', function () {
			$http.get("reset/ForgotPass/CheckResetToken?token=" + vm.token)
				.then(function (data) {
					vm.user = data.data;

					if (vm.user) {
						vm.isValid = true;
					}
					else {
						vm.msgClass = "bg-danger text-danger";
						vm.stringNo = 10147;
						vm.hideMsg = false;
					}
					return;
				});
		});

		vm.saveNewPassword = function () {
			vm.hideMsg = true;
			if (vm.newPass == vm.confirmPass) {
				encrypt(vm.newPass, function (encryptPwd) {
					vm.user.Pwd = encryptPwd;
					httpRequest.doPostRequest("api/users/ResetPassword?personKey=" + vm.user.PersonKey + "&pass=" + encryptPwd).then(function (data) {
						if (data == 0) {
							vm.isValid = false;
							vm.badPass = false;
							vm.noMatch = false;
							vm.successfulReset = true;
							$timeout(function () {
								$location.path('/login');
							}, 4000);
						}
						else {
							vm.msgClass = "bg-danger text-danger";
							vm.badPass = true;
						}
					}, null);
				});
			} else {
				vm.msgClass = "bg-danger text-danger";
				vm.badPass = true;
			}
		};

		vm.passBlur = function () {
			//var regexObj = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/;
			//var regexObj = /^[a - zA - Z\d]{8,20}$/;
			var regexObj = /^(?=.*[\d*~@#$ %^&*+=`|{}:;!.?\"()\[\]-])(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,20}$/;
			if (regexObj.test(vm.newPass)) {
				vm.badPass = false;
			}
			else {
				vm.newPass = '';
				vm.badPass = true;
				$("#password").focus();
			}
		};

		vm.confirmPassBlur = function () {
			if (vm.confirmPass != vm.newPass) {
				vm.noMatch = true;
				vm.newPass = '';
				vm.confirmPass = '';
				$("#password").focus();
			}
			else {
				vm.noMatch = false;
			}
		};

        /*###############################################################################################################################
        Encrypt function
        Author: Josh Doran
        Company: aSa
        Purpose: encrypt a cleartext string using RSA and the public key provided
        method: 1. retrieve the key from the XML file
                2. encrypt the string
                3. return the encrypted string to the caller
    
        dependencies: all located in the /scripts folder
                      base64.js
                      ec.js
                      jsbn.js
                      jsbn2.js
                      prng4.js
                      rng.js
                      rsa.js
                      rsa2.js
                      sec.js
        ###############################################################################################################################*/
		function encrypt(clearText, callback) {
			var key_1024 = {};
			key_1024.n = "";
			key_1024.e = "";

			var jqxhr = $.get("app/login/Public.xml", function () { })
				.done(function (xml) {
					$(xml).find('RSAKeyValue').each(function () {
						key_1024.n = $(this).find('Modulus').text();
						key_1024.e = $(this).find('Exponent').text();
					});
					var rsa = new RSAKey();
					var hexn = b64tohex(key_1024.n);
					var hexe = b64tohex(key_1024.e);
					rsa.setPublic(hexn, hexe);
					var res = rsa.encrypt(clearText);
					callback(res);
				});
		}

		init();
	}
}());